const intensities: Mapping[] = [
  {
    label: '4',
    value: 0,
  },
  {
    label: '5弱',
    value: 1,
  },
  {
    label: '5強',
    value: 2,
  },
  {
    label: '6弱',
    value: 3,
  },
  {
    label: '6強',
    value: 4,
  },
  {
    label: '7',
    value: 5,
  },
];
export default intensities;
